module.exports = __webpack_public_path__ + "img/icon4.0a7f8ed3.png";